var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "selectComponent",
      staticClass: "select-component",
      class: _vm.computedClasses,
      style: _vm.computedStyles,
      on: { click: _vm.onSelectClick },
    },
    [
      _c(
        "span",
        {
          staticClass: "select-component-value",
          style: _vm.getValueStyles(_vm.computedInternalValue),
          attrs: { title: _vm.computedInternalValueText },
        },
        [
          _vm._t(
            "default",
            function () {
              return [
                _vm._v(
                  _vm._s(
                    _vm.computedInternalValueText ||
                      _vm.$t("components.select.placeholder")
                  )
                ),
              ]
            },
            {
              count:
                _vm.multiple && _vm.internalValue
                  ? _vm.internalValue.length
                  : undefined,
              text:
                _vm.computedInternalValueText ||
                _vm.$t("components.select.placeholder"),
              value: _vm.internalValue,
            }
          ),
        ],
        2
      ),
      _c("IconComponent", { attrs: { flop: _vm.isOpen } }, [
        _vm._v("drop_down"),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isOpen,
              expression: "isOpen",
            },
          ],
          ref: "selectComponentOptionsContainer",
          staticClass: "select-component-options-container",
          class: _vm.computedOptionsClasses,
        },
        [
          _c(
            "div",
            {
              ref: "selectComponentOptions",
              staticClass: "select-component-options",
              class: { "select-components-options-multiple": _vm.multiple },
              on: { click: _vm.onSelectOptionsClick },
            },
            [
              _c(
                "div",
                { staticClass: "select-component-options-wrapper" },
                _vm._l(_vm.options, function (item) {
                  return _c(
                    "div",
                    {
                      key: _vm.getOptionValue(item),
                      staticClass: "select-component-option",
                      class: {
                        "select-component-option-selected":
                          _vm.isOptionSelected(item),
                      },
                      style: _vm.getOptionStyles(item),
                      on: {
                        click: function ($event) {
                          return _vm.onOptionClick(item)
                        },
                      },
                    },
                    [
                      _vm.multiple
                        ? _c(
                            "CheckboxComponent",
                            {
                              attrs: { checked: _vm.isOptionSelected(item) },
                              on: {
                                change: function ($event) {
                                  return _vm.onOptionChange(item, $event)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.getOptionTitle(item)))]
                          )
                        : [
                            _c("span", [
                              _vm._v(_vm._s(_vm.getOptionTitle(item))),
                            ]),
                            _vm.isMobile && _vm.isOptionSelected(item)
                              ? _c("IconComponent", [_vm._v("check")])
                              : _vm._e(),
                          ],
                    ],
                    2
                  )
                }),
                0
              ),
              _vm.multiple
                ? _c("divider", { staticClass: "divider horizontal full" })
                : _vm._e(),
              _vm.multiple
                ? _c(
                    "div",
                    {
                      staticClass:
                        "select-component-option select-component-option-clear-all",
                      class: {
                        "select-component-option-disabled":
                          _vm.internalValue.length === 0,
                      },
                      on: { click: _vm.onClearAllClick },
                    },
                    [_vm._v(_vm._s(_vm.$t("components.select.clearAll")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }